export default "__VITE_ASSET__BHC8hGlt__"